import { Configuration, PlanningControllerApi, WbsInputListDto, WbsListDto } from '@api/client';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'core/store';
import getConfiguration, { errorHandler } from 'core/store/config';

enum PlanningActions {
  saveWbsPlanning = '[Planning] Save WBS Planning',
  getWbsProjectPlanningById = '[Planning] Get WBS Project Planning By Id',
  deleteWbsProjectPlanningById = '[Planning] Delete WBS Project Planning By Id',
  saveWbsDataTable = '[Planning] Save WBS Data Table',
}

export const saveWbsPlanning = createAsyncThunk<WbsListDto[] | undefined, WbsInputListDto[], ThunkApiConfig>(
  PlanningActions.saveWbsPlanning,
  async (payload, { dispatch, extra, getState }) => {
    try {
      return await new PlanningControllerApi(
        getConfiguration(Configuration, extra, getState)
      ).createOrUpdateWbsPlanning({ wbsInputListDto: payload });
    } catch (e) {
      errorHandler(e, dispatch, getState);
    }
  }
);

export const getWbsProjectPlanningById = createAsyncThunk<WbsListDto[] | undefined, number, ThunkApiConfig>(
  PlanningActions.getWbsProjectPlanningById,
  async (payload, { dispatch, extra, getState }) => {
    try {
      return await new PlanningControllerApi(
        getConfiguration(Configuration, extra, getState)
      ).getWbsAndPlanningByProjectId({ projectId: payload });
    } catch (e) {
      errorHandler(e, dispatch, getState);
    }
  }
);

export const deleteWbsProjectPlanningById = createAsyncThunk<void, number, ThunkApiConfig>(
  PlanningActions.deleteWbsProjectPlanningById,
  async (payload, { dispatch, extra, getState }) => {
    try {
      await new PlanningControllerApi(getConfiguration(Configuration, extra, getState)).deleteWbsPlanningAndWbs({
        id: payload,
      });
    } catch (e) {
      errorHandler(e, dispatch, getState);
    }
  }
);

export const saveWbsDataTable = createAction<WbsListDto[] | undefined>(PlanningActions.saveWbsDataTable);
